import { render, staticRenderFns } from "./VideoUpload.vue?vue&type=template&id=1036249b&scoped=true"
import script from "./VideoUpload.vue?vue&type=script&lang=js"
export * from "./VideoUpload.vue?vue&type=script&lang=js"
import style0 from "./VideoUpload.vue?vue&type=style&index=0&id=1036249b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036249b",
  null
  
)

export default component.exports